import { render, staticRenderFns } from "./AdaptedGoalView.vue?vue&type=template&id=364ee1c5&scoped=true"
import script from "./AdaptedGoalView.vue?vue&type=script&lang=js"
export * from "./AdaptedGoalView.vue?vue&type=script&lang=js"
import style0 from "./AdaptedGoalView.vue?vue&type=style&index=0&id=364ee1c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364ee1c5",
  null
  
)

export default component.exports